<template>
  <div>
    <form id="formdata" method="POST" action=""></form>
    <br />
    <div style="margin-top: 20px; text-align: center">
      <h3>Please do not close and refresh browser</h3>
    </div>
    <div style="color: red; margin-top: 20px; text-align: center">
      <h4>Redirect to payment getway website for payment</h4>
    </div>
    <div style="color: red; margin-top: 20px; text-align: center">
      <img src="../assets/images/payprocess.gif" />
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
import PaymentJS from "./serviceJS/paymentJS.js";
export default {
  name: "TransRequest",
  data() {
    return {
      EarlyBirdPC: 0,
      SpecialDiscountPC: 0,
    };
  },
  methods: {
    getdata(e) {
      const _data_ = {
        NomineeID: e,
        EarlyBirdPC: this.EarlyBirdPC,
        SpecialDiscountPC: this.SpecialDiscountPC,
        type: 1,
      };
      PaymentJS.TransRequest(_data_).then(
        (response) => {
          if (response.data.isSuccess) {
            document.getElementById("formdata").action = response.data.result;
            var keys = Object.keys(response.data.result1);
            var values = Object.values(response.data.result1);
            var data = "";
            for (var i = 0; i < keys.length; i++) {
              data +=
                "<input type='hidden' name='" +
                keys[i] +
                "' value='" +
                values[i] +
                "'/>";
            }
            document.getElementById("formdata").innerHTML = data;
            document.getElementById("formdata").submit();
          }
        },
        (error) => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        (failure) => {
          alert("Failure: " + failure.response);
        }
      );
    },
  },
  mounted() {
    if (this.$root.$data.NomAuthID != null) {
      this.EarlyBirdPC = this.$root.$data.EarlyBird;
      this.SpecialDiscountPC = this.$root.$data.Discount;
      this.getdata(this.$root.$data.NomAuthID);
    } else {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/TransRequest.vue